export default "__VITE_ASSET__DHV_GBDa__"